import React from 'react';
import { Lock } from 'lucide-react';
import { FormEmbed } from '../components/FormEmbed';
// Images for each session card
const CARD_IMAGES = {
  menopause: 'https://www.hypnobabies.com//wp-content/uploads/2023/08/86037407_m.jpg',
  anxiety: 'https://proears.com/wp-content/uploads/2025/05/Blog-Photo.jpg',
  sleep: 'https://hips.hearstapps.com/hmg-prod/images/young-asian-man-with-eyes-closed-enjoying-music-royalty-free-image-1703247514.jpg'
};
export function ResourcesV3() {
  return <div className="min-h-screen bg-white font-sans text-[#1e3a5f]" data-id="element-149">
      <main data-id="element-150">
        {/* HERO — text left, video right */}
        <section className="py-10 md:py-14 px-4 bg-[#eef4fb]" data-id="element-151">
          <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-10 items-center" data-id="element-152">
            <div className="space-y-5 order-1" data-id="element-153">
              <h1 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] leading-snug" data-id="element-154">
                Free guided hypnotherapy sessions
              </h1>
              <p className="text-gray-500 text-base leading-relaxed" data-id="element-155">
                Professional audio support designed to calm the mind and restore
                balance. Created by a registered, award-winning hypnotherapist.
              </p>
              <a href="#sessions" className="inline-block bg-[#1e3a5f] text-white px-7 py-3 rounded-lg font-semibold text-sm shadow-sm hover:bg-[#162d4a] transition-colors" data-id="element-156">
                Access your session
              </a>
            </div>

            {/* Video — styled, right side of hero */}
            <div className="order-2 flex justify-center md:justify-end" data-id="element-157">
              <div className="relative w-full max-w-[320px]" data-id="element-158">
                {/* Decorative ring behind video */}
                <div className="absolute -inset-3 rounded-3xl" style={{
                background: 'rgba(74,122,181,0.10)',
                zIndex: 0
              }} data-id="element-159" />
                <div className="relative rounded-2xl overflow-hidden border-2 border-white" style={{
                aspectRatio: '9/16',
                boxShadow: '0 8px 40px rgba(30,58,95,0.20)',
                zIndex: 1
              }} data-id="element-160">
                  <iframe width="100%" height="100%" src="https://www.youtube.com/embed/HmUfhvAQlWU" title="How these hypnotherapy sessions work" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 w-full h-full" data-id="element-161" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FORMS — primary focus */}
        <section id="sessions" className="py-14 px-4 bg-white" data-id="element-162">
          <div className="max-w-6xl mx-auto" data-id="element-163">
            <div className="text-center mb-10" data-id="element-164">
              <h2 className="text-2xl font-bold text-[#1e3a5f]" data-id="element-165">
                Download your free session
              </h2>
              <p className="text-gray-500 mt-2 text-sm" data-id="element-166">
                Choose a session and enter your details to receive your download
                link.
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6 items-stretch" data-id="element-167">
              {/* Card 1 — Menopause */}
              <div className="border border-gray-200 rounded-2xl overflow-hidden flex flex-col bg-white" style={{
              boxShadow: '0 4px 20px rgba(0,0,0,0.06)'
            }} data-id="element-168">
                {/* Image */}
                <div className="h-44 overflow-hidden" data-id="element-169">
                  <img src={CARD_IMAGES.menopause} alt="Calm and relaxed woman" className="w-full h-full object-cover" style={{
                  filter: 'brightness(0.92) saturate(0.85)'
                }} data-id="element-170" />
                </div>
                <div className="p-5 bg-[#eef4fb] border-b border-gray-100 text-center" data-id="element-171">
                  <h3 className="text-base font-bold text-[#1e3a5f]" data-id="element-172">
                    Menopause support
                  </h3>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-173">
                    Ease symptoms and restore calm.
                  </p>
                </div>
                <div className="p-4 flex flex-col flex-grow" data-id="element-174">
                  <div className="flex-grow" data-id="element-175">
                    <FormEmbed formId="poXAdqeTuzz4bBBs2MV9" formName="Menopause MP3" iframeId="inline-poXAdqeTuzz4bBBs2MV9-v3" height={420} data-id="element-176" />
                  </div>
                  <p className="text-[11px] text-center text-[#1e3a5f]/60 mt-3 flex items-center justify-center gap-1" data-id="element-177">
                    <Lock className="w-3 h-3 flex-shrink-0" data-id="element-178" />
                    Your details are kept strictly confidential.
                  </p>
                </div>
              </div>

              {/* Card 2 — Anxiety (most popular) */}
              <div className="border border-[#4a7ab5]/30 rounded-2xl overflow-hidden flex flex-col bg-white" style={{
              boxShadow: '0 4px 24px rgba(74,122,181,0.16)'
            }} data-id="element-179">
                {/* Most popular badge — inside card, above image */}
                <div className="bg-[#4a7ab5] text-white text-[11px] uppercase font-bold tracking-wider text-center py-2" data-id="element-180">
                  Most popular
                </div>
                {/* Image */}
                <div className="h-44 overflow-hidden" data-id="element-181">
                  <img src={CARD_IMAGES.anxiety} alt="Person feeling confident and calm" className="w-full h-full object-cover" style={{
                  filter: 'brightness(0.90) saturate(0.85)'
                }} data-id="element-182" />
                </div>
                <div className="p-5 bg-[#eef4fb] border-b border-gray-100 text-center" data-id="element-183">
                  <h3 className="text-base font-bold text-[#1e3a5f]" data-id="element-184">
                    Anxiety to confidence
                  </h3>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-185">
                    Build inner strength and calm.
                  </p>
                </div>
                <div className="p-4 flex flex-col flex-grow" data-id="element-186">
                  <div className="flex-grow" data-id="element-187">
                    <FormEmbed formId="poXAdqeTuzz4bBBs2MV9" formName="Anxiety MP3" iframeId="inline-anxiety-poXAdqeTuzz4bBBs2MV9-v3" height={420} data-id="element-188" />
                  </div>
                  <p className="text-[11px] text-center text-[#1e3a5f]/60 mt-3 flex items-center justify-center gap-1" data-id="element-189">
                    <Lock className="w-3 h-3 flex-shrink-0" data-id="element-190" />
                    Your details are kept strictly confidential.
                  </p>
                </div>
              </div>

              {/* Card 3 — Sleep */}
              <div className="border border-gray-200 rounded-2xl overflow-hidden flex flex-col bg-white" style={{
              boxShadow: '0 4px 20px rgba(0,0,0,0.06)'
            }} data-id="element-191">
                {/* Image */}
                <div className="h-44 overflow-hidden" data-id="element-192">
                  <img src={CARD_IMAGES.sleep} alt="Person resting peacefully with eyes closed" className="w-full h-full object-cover" style={{
                  filter: 'brightness(0.88) saturate(0.80)'
                }} data-id="element-193" />
                </div>
                <div className="p-5 bg-[#eef4fb] border-b border-gray-100 text-center" data-id="element-194">
                  <h3 className="text-base font-bold text-[#1e3a5f]" data-id="element-195">
                    Restful sleep
                  </h3>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-196">
                    Wake feeling refreshed and restored.
                  </p>
                </div>
                <div className="p-4 flex flex-col flex-grow" data-id="element-197">
                  <div className="flex-grow" data-id="element-198">
                    <FormEmbed formId="LUc3SIG5R30MtnKlbZ7r" formName="Sleep MP3" iframeId="inline-LUc3SIG5R30MtnKlbZ7r-v3" height={420} data-id="element-199" />
                  </div>
                  <p className="text-[11px] text-center text-[#1e3a5f]/60 mt-3 flex items-center justify-center gap-1" data-id="element-200">
                    <Lock className="w-3 h-3 flex-shrink-0" data-id="element-201" />
                    Your details are kept strictly confidential.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FINAL CTA */}
        <section className="py-10 px-4 bg-[#eef4fb] text-center border-t border-gray-100" data-id="element-202">
          <div className="max-w-sm mx-auto space-y-3" data-id="element-203">
            <p className="text-gray-500 text-sm" data-id="element-204">Prefer one to one support?</p>
            <a href="https://mindability-hypnotherapy.co.uk/location/" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#1e3a5f] text-white px-8 py-3 rounded-lg font-semibold text-sm hover:bg-[#162d4a] transition-colors" data-id="element-205">
              Book your consultation
            </a>
          </div>
        </section>
      </main>
    </div>;
}